import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import requestApi from '../../utils/request'
import { Col, Row } from 'react-bootstrap'
import SearchableDropDown from '../../components/SearchableDropDown/SearchableDropDown'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import InputControl from '../../components/InputControl'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'

//#region All Country
const getAllCountry = async () => {
    const countryList = await requestApi.post(
        '/country/list',
        { limit: 1000 },
        {},
        { headers: true }
    )
    return countryList.data
}
//#endregion

//#region GetConntact Data (View Data)
async function getContactusdata() {
    return await requestApi
        .post(`contact-us/view`, { })
        .then((res) => {
            return res.data
        })
}
//#endregion

//#region Validation Schema For Form
       const contactUsFormSchema = yup.object({
        email: yup.string().email("Please enter valid email").required('Please enter email'),
        phone: yup
            .string()
            .required('Please enter contact number')
            .matches(/^[0-9]+$/, {
                message: 'Mobile number must be in digits'
            })
            .min(6, 'Mobile number must be at least 6 digits')
            .max(12, 'Mobile number must be at most 12 digits'),
    })
    //#endregion

const Contactus = () => {
    const queryClient = useQueryClient()

    const [selectedCountryOptions, setselectedCountryOptions] = useState({
        _id:'64899170dc7f78ae40c64569', name: 'Algeria',sortname: "DZ",status:1
    })

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        reset,
        control 
    } = useForm(
      { resolver: yupResolver(contactUsFormSchema) }
    )

    //#region Country Listing
    const { data: CountryList } = useQuery({
        queryKey: ['countrylist', selectedCountryOptions],        
        queryFn: getAllCountry
    })
    //#endregion 

    const { data:contactusformdata, isLoading } = useQuery({
        queryKey: ['view-contactus'],
        queryFn: () => getContactusdata(),
        // enabled:!!CountryList,
        onSuccess: (data) => {
            reset({
                contactUsId:data?.data?.contactId,
                country:{
                    "_id": data?.data?.countryId,
                    "name": data?.data?.country,
                },    
                phone:data?.data?.phone,
                email:data?.data?.email
            }) 
        }
    })
    console.log(selectedCountryOptions,"selectedCountryOptions");
    
    async function EditContactData(payload) {
            return await requestApi
                .post(
                    `contact-us/edit`,
                   {...payload} 
                )
                .then((res) => {
                    return res.data
                })
    }

    const mutation = useMutation(EditContactData, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(()=>{
                queryClient.invalidateQueries('view-contactus')  
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })


    const contactFormHandle = (data) => {
        let {country,...rest}=data
        mutation.mutate({...rest,countryId:country?._id}) 
    }
    
    return (
        <>
            <div className="admin-card">
                <div class="head">
                    <h2>Contact us</h2>
                </div>
                <div className="admin-form-body">
                    {isLoading ? (
                        <div></div>
                    ) : (
                        <form onSubmit={handleSubmit(contactFormHandle)}>
                            <Row>
                                <Col lg="4" md="6" sm="12">
                                    <div className="form-group">
                                        <label>Country</label>
                                        
                                        <SearchableDropDown
                                            control={control}
                                            options={CountryList?.data}
                                            value={selectedCountryOptions}
                                            name="country"
                                            onSelect={(e) =>setselectedCountryOptions(e)}
                                        />
                                    </div>
                                </Col>
                                <Col xxl="4" lg="6" md="6">
                                    <InputControl
                                        label="Email Address"
                                        name="email"
                                        register={register}
                                        error={errors.email?.message}
                                    />
                                </Col>
                                <Col xxl="4" lg="6" md="6">
                                    <InputControl
                                        label="Contact No."
                                        type="number"
                                        name="phone"
                                        register={register}
                                        error={errors.phone?.message}
                                    />
                                </Col>
                                <Col lg="12">
                                    <button
                                        className="solid-red-btn"
                                        type="submit"
                                    >
                                        Save
                                    </button>
                                </Col>
                            </Row>
                        </form>
                    )}
                </div>
            </div>
        </>
    )
}

export default Contactus
